import { LocalStorageSaveOptions, CacheService } from './cache.service';
import {Api} from '../config/api';
import {Base64Service} from './base64.service';
import {CryptoService} from './crypto.service';
import {SessionService} from './session.service';
import {Injectable} from '@angular/core';
import {RequestOptions, Http} from '@angular/http';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import {AES, SHA256, PBKDF2} from 'crypto-js';

import * as CryptoJS from 'crypto-js';
import { timeout } from 'rxjs/operator/timeout';


export class QSCacheOptions {
  cacheMins?: number;
  cacheKey: string;
}

@Injectable()
export class RequestService {

  public bIsRequesting = false;

  private excludeUrls = [Api.Agent.TransactionSender, Api.Agent.TransactionRate];

  private readonly DELAY_TIME = 450;

  public enc_pad = null;

  private readonly PASS_SHA = 10;

  private readonly PASS_SALT = 'edZiYWwetzgSh^QAebw^CNyEOAG(tIgkGXo@@7VpBFHKOuEBeCpRdFYNE*!@a^yB!vlVJ0o&&4S#I^GaNszuHBi8^qcXThWBL%5*iq_*lvoBsW^vWUC$0)CnltZw#CzQv+aoWH0+kd*Uc%w^js8qSt7JLRcPq&K#xl_iNP$GBP9Yg!Qw&11TDE42W$xa%JzB%+XRPRPb!+xN*k(j)$8#M_F!in&VBYfWxi(g%N8+yD+wvJoT4!loY0KXdX$NXsZ9';

  constructor(
    private http: Http,
    private sessionService: SessionService,
    public base64Service: Base64Service,
    private cryptoService: CryptoService,
    private router: Router,
    private cacheService: CacheService) {

  }


  public _raw(): Http {
    return this.http;
  }

  public requestStatus(): boolean {
    return this.bIsRequesting;
  }

  private makePassphrase(): string {

    if (!this.enc_pad) {
      this.enc_pad = this.sessionService.SessionCryptKey;
    }

    let tempphrase = this.enc_pad;


    for (let i = 0; i < this.PASS_SHA; i++) {
      tempphrase = SHA256(tempphrase.toString() + this.PASS_SALT);
    }
    return tempphrase.toString();
  }

  public postCacheMode<T>(url: string, options: RequestOptions, data: any, T, cacheMins?: number): Observable<T> {
    return this.post(url, options, data, T, cacheMins || 5);
  }

  public postBasic<T>(url: string, options: RequestOptions, data: any, T): Observable<T> {
    return this.post(url, options, data, T, null);
  }

  public post<T>(url: string, options: RequestOptions, data: any, T, cacheMins: number): Observable<T> {
    let cacheData;
    let cacheOption;
    if (cacheMins) {
      cacheOption = new QSCacheOptions();
      cacheOption.cacheKey = this.cryptoService.sha256(url);
      cacheOption.cacheMins = cacheMins;
    }
    if (cacheOption) {
      cacheData = this.cacheService.load(cacheOption.cacheKey);
      if (cacheData) {
        if (cacheOption.cacheMins > 0) {
          if (cacheData) {
            return Observable.of<T>(cacheData);
          }
        }
      }
    }
    if (!(this.excludeUrls.indexOf(url) > -1)) {
      this.bIsRequesting = true;
    }
    let body: any = this.base64Service.encode(JSON.stringify(data));
    data = null;
    if (this.enc_pad || this.sessionService.SessionCryptKey) {
      body = AES.encrypt(body, this.makePassphrase());
      body = btoa(atob(body.toString()).replace('Salted__', ''));
    }

    options.headers.set('Authorization', this.sessionService.getToken());
    options.headers.set('Content-Type', 'application/qsremit-encoded-form');
    options.headers.set('Accept', 'application/qsremit-encoded-form');
    if (this.enc_pad) {
      options.headers.set('x-qs-pad', this.enc_pad);
    }
    const request = this.http.post(url, '', {body: body, headers: options.headers})
      .map(
      (response) => {
        let payload;
        let resData;
        const enc_pad = response.headers.get('x-qs-pad');
        if (enc_pad) {
          this.enc_pad = enc_pad;
          this.sessionService.SessionCryptKey = enc_pad;
          payload = JSON.parse(this.base64Service.decode(this.cryptoService.aesDecrypt(response.text(), this.makePassphrase())));
        } else {
          payload = JSON.parse(this.base64Service.decode(response.text()));
        }
        if (response.status > 199 && response.status < 300) {
          if (response.headers.get('Authorization')) {
            this.sessionService.setToken(response.headers.get('Authorization'));
          }
          if (response.headers.get('Set-Cookie')) {
            this.sessionService.setSession(response.headers.get('Set-Cookie'));
          }
          if (response.status === 226) {
            this.showDuplicateAlert(payload.message);
          }
        }
        resData = <T>Object.assign(new T(), payload);
        let localCacheOption;
        if (!cacheData && cacheOption && cacheOption.cacheKey) {
          localCacheOption = new LocalStorageSaveOptions(cacheOption.cacheKey);
        }
        if (localCacheOption) {
          if (resData) {
            localCacheOption.data = new T();
            Object.assign(localCacheOption.data, resData);
            localCacheOption.expirationMins = cacheOption.cacheMins || 5;
            this.cacheService.save(localCacheOption);
          }
        }
        return resData;
      }).timeout(5 * 60 * 1000).catch(this._errorHandle);
    return Observable.from(request).do(() => {this.bIsRequesting = true; }).delay(this.DELAY_TIME).finally(() => {
      this.bIsRequesting = false;
    });
  }

  public getNoWait<T>(url: string, options: RequestOptions, T): Observable<T> {
    return this.get(url, options, T, true, null);
  }

  public getCacheMode<T>(url: string, options: RequestOptions, T, cacheMins?: number): Observable<T> {
    return this.get(url, options, T, false, cacheMins || 5);
  }

  public getBasic<T>(url: string, options: RequestOptions, T): Observable<T> {
    return this.get(url, options, T, false, null);
  }

  public get<T>(url: string, options: RequestOptions, T, noWait: boolean, cacheMins: number): Observable<T> {
    let cacheData;
    let cacheOption;
    if (cacheMins) {
      cacheOption = new QSCacheOptions();
      cacheOption.cacheKey = this.cryptoService.sha256(url);
      cacheOption.cacheMins = cacheMins;
    }
    if (cacheOption) {
      cacheData = this.cacheService.load(cacheOption.cacheKey);
      if (cacheData) {
        if (cacheOption.cacheMins > 0) {
          if (cacheData) {
            return Observable.of<T>(cacheData);
          }
        }
      }
    }
    options.headers.set('Authorization', this.sessionService.getToken());
    options.headers.set('Content-Type', 'application/qsremit-encoded-form');
    options.headers.set('Accept', 'application/qsremit-encoded-form');
    let request: Observable<any> = this.http.get(url, {headers: options.headers});
    this.bIsRequesting = true;
    if (noWait !== true) {
      request = request.map((response) => {
        let resData;
        const enc_pad = response.headers.get('x-qs-pad');
        if (enc_pad) {
          this.enc_pad = enc_pad;
          this.sessionService.SessionCryptKey = enc_pad;
          resData = <T>Object.assign(new T(), JSON.parse(this.base64Service.decode(this.cryptoService.aesDecrypt(response.text(), this.makePassphrase()))));
        } else {
          resData = <T>Object.assign(new T(), JSON.parse(this.base64Service.decode(response.text())));
        }
        let localCacheOption;
        if (!cacheData && cacheOption && cacheOption.cacheKey) {
          localCacheOption = new LocalStorageSaveOptions(cacheOption.cacheKey);
        }
        if (localCacheOption) {
          if (resData) {
            localCacheOption.data = new T();
            Object.assign(localCacheOption.data, resData);
            localCacheOption.expirationMins = cacheOption.cacheMins || 5;
            this.cacheService.save(localCacheOption);
          }
        }
        return resData;
      }).timeout(5 * 60 * 1000).catch(this._errorHandle);
      return Observable.from(request).do(() => {
        this.bIsRequesting = true;
      }).delay(this.DELAY_TIME).finally(() => {
        this.bIsRequesting = false;
      });
    } else {
      request.subscribe();
      return Observable.of(new T()).delay(this.DELAY_TIME)
      .finally(() => {
        this.bIsRequesting = false;
      });
    }
  }

  _errorHandle(response: Response) {
    if (response.status === 401) {
      delete this.enc_pad;
    }
    return Observable.throw(response);
  }

  private showDuplicateAlert(ip: string) {
    let message = 'This user is currently connected from ' + ip;
    message = message + '\nPrevious connection will be logged out instantly.';
    alert(message);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/request.service.ts